import axios from 'axios';

import AWS from 'aws-sdk';
import { postAws } from '../aws';
  const API_URL = 'http://localhost:5000/api';

  //https://api-dev.aurait.ai
  

const region = import.meta.env.VITE_AWS_REGION;
const service = 'execute-api';

const credentials = new AWS.Credentials({
  accessKeyId: import.meta.env.VITE_AWS_ACCESS_KEY_ID, 
  secretAccessKey: import.meta.env.VITE_AWS_SECRET_ACCESS_KEY,  // Your AWS Secret Access Key
});

async function getAws(api) {
  try {
    const signRequest = async (url) => {
      const endpoint = new URL(url);
      const request = new AWS.HttpRequest(endpoint, region);
      request.method = 'GET';
      request.path = endpoint.pathname + endpoint.search; // Ensures query params are included
      request.headers['host'] = endpoint.host;
      request.headers['Content-Type'] = 'application/json';
  
      const signer = new AWS.Signers.V4(request, service);
      signer.addAuthorization(credentials, new Date());
      
      // Filter out 'host' header as browsers set it automatically
      const headers = {};
      for (const [key, value] of Object.entries(request.headers)) {
        if (key.toLowerCase() !== 'host') {
          headers[key] = value;
        }
      }
      
      return headers;
    };
  
    const signedHeaders = await signRequest(api);

    const response = await axios({
      method: 'get',
      url: api,
      headers: signedHeaders,
    });

    return response.data;

  } catch (error) {
    console.error('Error in getAws:', error);
    throw error; // Re-throw the error so the calling function can handle it
  }
}


export const getAllNotification = async (userId) => {
  const response = await getAws((`https://api-dev.aurait.ai/alert?id=${userId}`))
  return response;
} 

export const getAllnotes = async (classRoomId, userId) => {
  const response = await getAws((`https://api-dev.aurait.ai/notes/allNotes?classRoomId=${classRoomId}&userId=${userId}`))
  return response;
}

export const getAllAssigmentData=async (classRoomId) => {
  const response=await getAws((`https://api-dev.aurait.ai/assignment/classRoom?id=${classRoomId}`));
  return response.body;

}

export const getAllQuizData = async (classRoomId) => {
  const response = await getAws(`https://api-dev.aurait.ai/quiz/ClassRoom?id=${classRoomId}`)
  return response.body
}

export const getAssignmentSubmissions = async (studentId, classRoomId) => {
  const fetchSubmission = {
    body: {
      studentId: studentId,
      classRoomId: classRoomId
    },
    request: 'get-student-submission'
  }
  const response = await postAws('https://api-dev.aurait.ai/submission', 'POST', fetchSubmission);
  console.log(response)
  return response.body;
}

export const getQuizSubmissions = async (studentId, classRoomId) => {
  const fetchSubmission = {
    body: {
      studentId: studentId,
      classRoomId: classRoomId,
    },
    request: "get-student-quiz-submissions",
  }
  const response = await postAws("https://api-dev.aurait.ai/quizSubmission", "POST", fetchSubmission)
  console.log(response)
  return response.body
}


export const getMessages = async (gid, before = null, limit = 100) => {
  let url = `https://api-dev.aurait.ai/chat/messages?id=${gid}&limit=${limit}`;
  
  // Add the 'before' parameter if provided
  if (before) {
    url += `&before=${before}`;
  }
  
  const response = await getAws(url);
  return response.body;
}


export const getConversation = async (userId) => {
  const response = await getAws((`https://api-dev.aurait.ai/chat?id=${userId}`))
  return response.body;
}

export const getEvaluatedAssignmentAndQuiz = async (studentId) => {
  const response = await getAws((`https://api-dev.aurait.ai/evaluatedAssignmentAndQuizStudent?studentId=${studentId}`))
  return response;
}

export const getContacts = async (userId) => {
  const response = await getAws((`https://api-dev.aurait.ai/chat/contacts?id=${userId}`))
  return response.body;
}
export const getCourseDetials = async (courseId) => {
  try {
    console.log("Calling getCourseDetials with courseId:", courseId)
    const url = `https://api-dev.aurait.ai/eLearning?courseId=${courseId}`
    console.log("API URL:", url)

    const response = await getAws(url)
    console.log("Raw API response:", response)

    if (!response || !response.body) {
      throw new Error("Invalid response from API")
    }

    return response.body
  } catch (error) {
    console.error("Error in getCourseDetials:", error)
    throw error
  }
}

export const getAnnouncements = async (classRoomId) => {
  const response = await getAws((`https://api-dev.aurait.ai/announcement?id=${classRoomId}`))
  return response.body.data;
}

export const getSubmissionDetials=async(submssionId)=>{
  const response =await getAws(`https://api-dev.aurait.ai/submission?id=${submssionId}`)
  console.log("response for submission is",response);

  return response;
}

export const getQuizSubmissionDetail=async(submssionId)=>{
  const response =await getAws(`https://api-dev.aurait.ai/quizSubmission?id=${submssionId}`)
  console.log("response for submission is",response);

  return response;
}

export const getAllbooks = async (classRoomId) => {
  const response = await getAws((`https://api-dev.aurait.ai/library/allBooks?id=${classRoomId}`))
  return response;
}
export const getbook = async (bookId) => {
  const response = await getAws((`https://api-dev.aurait.ai/library?id=${bookId}`))
  return response.body;
}

export const getExamSubmissionDetails=async(submssionId)=>{
  const response =await getAws(`https://api-dev.aurait.ai/examSubmission?id=${submssionId}`)
  console.log("response for submission is",response);

  return response;
}
export const getClassData = async (classId) => {
  const classData = await getAws(`https://api-dev.aurait.ai/classroom?id=${classId}`)
  return classData.body.data;

}

export const getAssignmentData = async (assignmentId) => {
  const assignmentData = await getAws(`https://api-dev.aurait.ai/assignment?id=${assignmentId}`)
  return assignmentData.body.data;
}

export const getQuizData = async (assignmentId) => {
  const assignmentData = await getAws(`https://api-dev.aurait.ai/quiz?id=${assignmentId}`)
  return assignmentData;
}

export const getExamData = async (examId) => {
  const examData = await getAws(`https://api-dev.aurait.ai/exam?id=${examId}`);

  const examObject = JSON.parse(examData.body);

  return examObject.data;
}

  export const fetchSubmittedAssignments = async (selectedClass, selectedSubject) => {
    try {
      const response = await axios.get(`${API_URL}/fetch-submitted-assignments`, {
        params: { class: selectedClass, subject: selectedSubject },
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching submitted assignments:', error);
      throw error;
    }
  };

  // Add this function to your api.js file
  export const fetchSubmittedAssignmentDetails = async (id) => {
    try {
      const response = await axios.get(`${API_URL}/submitted-assignment/${id}`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching submitted assignment details:', error);
      throw error;
    }
  };
  

  export const fetchAssignments = async (selectedClass, selectedSubject) => {
    try {
      const response = await axios.get(`${API_URL}/assignments`, {
        params: { class: selectedClass, subject: selectedSubject },
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching assignments:', error);
      if (error.response) {
        console.error('Response data:', error.response.data);
        console.error('Response status:', error.response.status);
        console.error('Response headers:', error.response.headers);
      }
      throw error;
    }
  };
  
  export const getStudentInfo=async()=>{
    const studentid=localStorage.getItem("studentId");
    const response=await getAws(`https://api-dev.aurait.ai/student?id=${studentid}`);
    localStorage.setItem('studentData', JSON.stringify(response.body.data));
    return response;


  }
  export const logoutStudent=async()=>{
    localStorage.removeItem("token");
    localStorage.removeItem("studentId");
    
  }
  export const fetchAssignmentDetails = async (id) => {
    try {
      const response = await axios.get(`${API_URL}/assignment/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching assignment details:', error);
      throw error;
    }
  };

  export const signupStudent = async (studentData) => {
    try {
      const response = await axios.post(`${API_URL}/auth/signupStudent`, studentData);
      return response.data;
    } catch (error) {
      if (error.response) {
        throw new Error(error.response.data.error || 'An error occurred during signup');
      } else if (error.request) {
        throw new Error('No response received from server');
      } else {
        throw new Error('Error setting up the request');
      }
    }
  };
  
  export const verifyOtp = async (email, otp) => {
    try {
      const response = await axios.post(`${API_URL}/auth/verify-otp/Student`, { email, otp });
      return response.data;
    } catch (error) {
      if (error.response) {
        throw new Error(error.response.data.error || 'An error occurred during OTP verification');
      } else if (error.request) {
        throw new Error('No response received from server');
      } else {
        throw new Error('Error setting up the request');
      }
    }
  };

  
  export const loginStudent = async (identifier, password) => {
    
    const loginData = {
      body: {
        teacherEmail: identifier,
        password: password
      },
      request: "login-Student"
    }
    try {
      const response = await postAws("https://api-dev.aurait.ai/auth/student-auth", "POST", loginData);
      console.log('Login response:', response);
  
      if (response && response.token && response.studentId) {
        localStorage.setItem('token', response.token);
        localStorage.setItem('studentId', response.studentId);
        console.log('Token and studentId stored in localStorage');
        return response;
      } else if (response && response.statusCode) {
        // Handle different status codes
        switch (response.statusCode) {
          case 400:
            throw new Error(response.body?.error || 'Incorrect Password');
          case 401:
            throw new Error(response.message || 'Invalid credentials');
          case 404:
            throw new Error(response.message || 'Student not found');
          default:
            throw new Error(response.message || 'An error occurred during login');
        }
      } else {
        console.error('Invalid response from server:', response);
        throw new Error('Invalid response from server');
      }
    } catch (error) {
      console.error('Login error:', error);
      throw error; // Throw the error object directly
    }
  };
  
  export const resetPassword = async (token, newPassword) => {
    try {
      const response = await axios.post(`${API_URL}/auth/reset-password/Student`, { token, newPassword });
      return response.data;
    } catch (error) {
      if (error.response) {
        throw new Error(error.response.data.error || 'An error occurred while resetting your password');
      } else if (error.request) {
        throw new Error('No response received from server');
      } else {
        throw new Error('Error setting up the request');
      }
    }
  };
  
  export const getSubjects = async () => {
    try {
      const response = await axios.get(`${API_URL}/student/subjects`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Error fetching subjects');
    }
  };
  
const setAuthToken = (token) => {
  if (token) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  } else {
    delete axios.defaults.headers.common['Authorization'];
  }
};
const token = localStorage.getItem('token');
if (token) {
  setAuthToken(token);
}

export const sendEnrollmentRequest = async (classCode) => {
  const studentId = localStorage.getItem("studentId");
  const enrollmentData = {
    body: {
      classCode: classCode,
      studentId: studentId
    },
    request: "send-Request"
  };
  console.log(enrollmentData);
  
  try {
    const response = await postAws(`https://api-dev.aurait.ai/enrollment`, "POST", enrollmentData);
    console.log("Full response from postAws:", response);
    
    // Check if the response has the expected structure
    if (response && response.statusCode) {
      if (response.statusCode === 201) {
        return {
          statusCode: response.statusCode,
          message: response.message || 'Enrollment Request sent'
        };
      } else {
        // For other status codes, throw an error with the message from the response
        throw new Error(response.message || 'Failed to send enrollment request');
      }
    } else {
      throw new Error('Unexpected response structure');
    }
  } catch (error) {
    console.error("Error in sendEnrollmentRequest:", error);
    throw error; // Re-throw the error to be handled in the component
  }
};




export const getEnrollmentRequests = async () => {
  try {
    const response = await axios.get(`${API_URL}/student/enrollment-requests`);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Error fetching enrollment requests');
  }
};
export const deleteEnrollmentRequest = async (classCode) => {
  try {
    const response = await fetch(`${API_URL}/student/enroll/${classCode}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
      },
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to delete enrollment request');
    }

    return await response.json();
  } catch (error) {
    console.error('Error deleting enrollment request:', error);
    return { error: error.message };
  }
};